/**
 * Plugin: "dropdown_header" (Tom Select)
 * Copyright (c) contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 */

import { htmlToElement, getDom } from './Html'
export default function (tomselect, userOptions) {
  console.log('clear_plugin2', tomselect, userOptions)
  console.log('clear_plugin2 this', this)
  // const self = this;

  const options = Object.assign(
    {
      className: 'clear-button',
      title: 'Clear All',
      wrapper: () => {
        return `<div style="flex: 1; display: flex; flex-direction: row; justify-content: flex-end;"></div>`
      },
      button: (data) => {
        return `<div style="align-self: flex-end; padding: 0px 5px" title="${data.title} class="${data.className} fa-solid fa-xmark fa-color-danger"><i class="fa-solid fa-xmark fa-color-danger""></i></div>`
      }
    },
    userOptions
  )

  this.hook('after', 'setup', function () {
    console.log('after setup!!')
    var button = getDom(options.button(options))
    var wrapper = getDom(options.wrapper())
    wrapper.appendChild(button)

    button.addEventListener('click', (evt) => {
      if (this.isLocked) return

      this.clear()

      if (this.settings.mode === 'single' && this.settings.allowEmptyOption) {
        this.addItem('')
      }

      evt.preventDefault()
      evt.stopPropagation()
    })
    this.control.appendChild(wrapper)
  })
}
